module.exports = __webpack_public_path__ + "static/img/gdjt3.407514e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdjt3.png
// module id = cy1y
// module chunks = 1